import React from 'react';

import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import { assetUrl } from '../../../../helpers/assetUrl';
import { DEFAULT_LOGO_CONF } from './helpers';

const useStyles = makeStyles(() => ({
  imageLink: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '64px',
  },
  withShadow: {
    filter: 'drop-shadow(0px 5px 10px rgba(0, 0, 0, 0.15))',
  },
}));

export interface LogoConfig {
  fileName: string;
  width: number;
  label: string;
}

interface ToolbarLogoProps {
  textLogoFileConfig?: LogoConfig;
}

export default function ToolbarLogo(props:ToolbarLogoProps) {
  const { textLogoFileConfig = DEFAULT_LOGO_CONF } = props;
  const homePageLink = window.location.origin;

  const classes = useStyles();
  return (
    <>
      <Box display={{ xs: 'none', sm: 'none', lg: 'block' }}>
        <a href={homePageLink} className={classes.imageLink}>
          <img
            src={assetUrl(`/images/logos/${textLogoFileConfig.fileName}`)}
            alt={textLogoFileConfig.label}
            width={textLogoFileConfig.width}
          />
        </a>
      </Box>

      <Box display={{ xs: 'none', sm: 'block', md: 'block', lg: 'none' }}>
        <a href={homePageLink} className={classes.imageLink}>
          <img
            src={assetUrl(`/images/logos/${DEFAULT_LOGO_CONF.fileName}`)}
            alt={DEFAULT_LOGO_CONF.label}
            width={DEFAULT_LOGO_CONF.width}
          />
        </a>
      </Box>

      <Box display={{ xs: 'block', sm: 'none' }}>
        <a href={homePageLink} className={classes.imageLink}>
          <img
            className={classes.withShadow}
            src={assetUrl('/images/logos/logo-app.svg')}
            alt="Tertius"
            height="32"
          />
        </a>
      </Box>
    </>
  );
};